import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Response, Service } from '../models/service';

@Injectable({
  providedIn: 'root'
})
export class RevenueInvoiceEventService extends Service<any> {
  protected override readonly URL: string = `${environment.url}/revenue_invoice_events`;

  constructor(protected override httpClient: HttpClient) { 
    //console.log(environment.production);
    super(httpClient);
  }

  getCreditTax() {
    return this.httpClient.get(`${environment.url}/tax`) as Observable<any[]>;
  }


  post(revenue: any) {
    return this.httpClient.post(`${environment.url}/revenue_invoice_events`, revenue)
  }

  getAllMachinePayment(queryParam: string = '') {
    return this.httpClient
    .get(`${environment.url}/machine_orders${queryParam}`).pipe(map((res: any) => 
      new Response(res["hydra:member"], res["hydra:view"], res["hydra:totalItems"], this)
    )) as Observable<Response<any>>;
  }


  getPerson(taxId: string) {
    return this.httpClient.get(`${environment.url}/help/person/taxid`, {
      params: {
        taxId
      }
    })
  }

  update(revenue: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.httpClient.patch(`${environment.url}/revenue_invoice_events/${revenue.id}`, revenue, {headers: headers})
  }


  getDataGraph(days: any = 7, filter: string = "") {
    return this.httpClient
    .get(`${environment.url}/graph/invoicing/${days}${filter}`) as Observable<any[]>;
  }

  
}
